import * as types from './types';

// see https://bud.apps.det.nsw.edu.au/api/v1/index#/

export default {

  async fetchBUDMetricsWan({dispatch, commit}, {siteCode, dateRange}) {
    let queries = [];
    if (dateRange) {
      if (dateRange.startDate) {
        queries.push(`startDate=${dateRange.startDate}`);
      }
      if (dateRange.endDate) {
        queries.push(`endDate=${dateRange.endDate}`);
      }
    }

    commit(types.BUD_WAN_FETCH_REQUEST);

    const inboundPromise = dispatch('api', {
      method: 'GET',
      url: `/bud-proxy/metrics/inbound/wan/${siteCode}?${queries.join('&')}`,
      types: [
        types.BUD_WAN_INBOUND_REQUEST,
        types.BUD_WAN_INBOUND_SUCCESS,
        types.BUD_WAN_INBOUND_FAILURE,
      ]
    });

    const outboundPromise = dispatch('api', {
      method: 'GET',
      url: `/bud-proxy/metrics/outbound/wan/${siteCode}?${queries.join('&')}`,
      types: [
        types.BUD_WAN_OUTBOUND_REQUEST,
        types.BUD_WAN_OUTBOUND_SUCCESS,
        types.BUD_WAN_OUTBOUND_FAILURE,
      ]
    });

    const values = await Promise.all([inboundPromise, outboundPromise]);
    if (Array.isArray(values) && values.length > 1) {
      let inboundData = null;
      let outboundData = null;
      if (values[0] && values[0].data) {
        inboundData = values[0].data;
      }
      if (values[1] && values[1].data) {
        outboundData = values[1].data;
      }
      commit(types.BUD_WAN_FETCH_SUCCESS, {
        inbound: inboundData,
        outbound: outboundData
      });
    }
  },

  async fetchBUDMetricsInternet({dispatch, commit}, {siteCode, dateRange}) {
    let queries = [];
    if (dateRange) {
      if (dateRange.startDate) {
        queries.push(`startDate=${dateRange.startDate}`);
      }
      if (dateRange.endDate) {
        queries.push(`endDate=${dateRange.endDate}`);
      }
    }

    commit(types.BUD_INTERNET_FETCH_REQUEST);

    const inboundPromise =  dispatch('api', {
      method: 'GET',
      url: `/bud-proxy/metrics/inbound/internet/${siteCode}?${queries.join('&')}`,
      types: [
        types.BUD_INTERNET_INBOUND_REQUEST,
        types.BUD_INTERNET_INBOUND_SUCCESS,
        types.BUD_INTERNET_INBOUND_FAILURE,
      ]
    });

    const outboundPromise =  dispatch('api', {
      method: 'GET',
      url: `/bud-proxy/metrics/outbound/internet/${siteCode}?${queries.join('&')}`,
      types: [
        types.BUD_INTERNET_OUTBOUND_REQUEST,
        types.BUD_INTERNET_OUTBOUND_SUCCESS,
        types.BUD_INTERNET_OUTBOUND_FAILURE,
      ]
    });

    const values = await Promise.all([inboundPromise, outboundPromise]);
    if (Array.isArray(values) && values.length > 1) {
      let inboundData = null;
      let outboundData = null;
      if (values[0] && values[0].data) {
        inboundData = values[0].data;
      }
      if (values[1] && values[1].data) {
        outboundData = values[1].data;
      }
      commit(types.BUD_INTERNET_FETCH_SUCCESS, {
        inbound: inboundData,
        outbound: outboundData
      });
    }
  },

  async fetchBUDBandwidth({dispatch, commit}, {siteCode}) {
    const response = await dispatch('api', {
      method: 'GET',
      url: `/bud-proxy/bandwidth/${siteCode}`,
      types: [
        types.BUD_BANDWIDTH_FETCH_REQUEST,
        types.BUD_BANDWIDTH_FETCH_SUCCESS,
        types.BUD_BANDWIDTH_FETCH_FAILURE,
      ]
    });
    return response;
  }
}
